import { render, staticRenderFns } from "./ServiceChargeWallet.vue?vue&type=template&id=27f27228&scoped=true&mlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./ServiceChargeWallet.vue?vue&type=script&lang=js&"
export * from "./ServiceChargeWallet.vue?vue&type=script&lang=js&"
import style0 from "./ServiceChargeWallet.vue?vue&type=style&index=0&id=27f27228&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f27228",
  null
  
)

component.options.__file = "ServiceChargeWallet.vue"
export default component.exports